import React, { useState, useEffect } from 'react'
import PropTypes from "prop-types";


// css
import '../../assets/css/modal.css'


const CustomFormTitle = ({ 
    defaultTitle = undefined, 
    domainObject = {}
}) => {

    const [title, setTitle] = useState('');


    useEffect(() => {
        if (defaultTitle) {
            setTitle(defaultTitle);
            return
        } 

        setTitle(domainObject?.title || domainObject?.name || '');

    }, [defaultTitle, domainObject]);
    


    return <>
        <label className='form-title'> { title } </label>
        {
            domainObject && (
                <div className='uid-section-title uid-hover-copy'>
                    <label>uid:</label>{' '}
                    {
                        domainObject?.uid && <>
                            <span
                                className='copy-uid-span'
                                title='Copiar UID'
                                onClick={() => {
                                    if(!domainObject?.urlFbConsole){
                                        navigator.clipboard.writeText(domainObject.uid);
                                        return;
                                    }

                                    window.open(domainObject?.urlFbConsole, '_blank');
                                }}
                            >
                                { domainObject.uid }
                                <i className={`title-icoon ${domainObject?.urlFbConsole ? 'fa fa-external-link' : 'fa fa-clipboard'}`} aria-hidden="true" />                                
                            </span>
                        </>
                    }
                </div>
            )
        }
    </>
}

CustomFormTitle.propTypes = {
    defaultTitle: PropTypes.string,
    path: PropTypes.string,
}

export default CustomFormTitle;